module.exports = __webpack_public_path__ + "img/ieyasu.77578f6f.jpg";